import React, { useState } from 'react';
import { FaSearch, FaSlidersH, FaAngleDown } from 'react-icons/fa';

const WorkflowSortToolbar = ({ onSearch, onSort }) => {
  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'Inactive' },
  ];

  const [searchText, setSearchText] = useState('');
  const [sortOpen, setSortOpen] = useState(false);
  const [sortOption, setSortOption] = useState('All Status');

  const toggleSort = () => {
    setSortOpen(!sortOpen);
  };

  /* const handleSortChange = (option) => {
    setSortOption(option);
    onSort(option); // Trigger the sort logic
  };*/

  const handleSortChange = (value) => {
    const selectedOption = statusOptions.find(
      (option) => option.value === value
    );
    setSortOption(selectedOption ? selectedOption.label : 'All Status');
    setSortOpen(false); // Close dropdow
    onSort(value); // Trigger the sort logic
  };

  return (
    <div style={{ display: 'flex', gap: '10px', padding: '0px' }}>
      {/* Search Box */}
      <div style={{ position: 'relative' }}></div>

      {/* Sort By Dropdown */}
      <div style={{ position: 'relative' }}>
        <button
          onClick={toggleSort}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            justifyContent: 'space-between', // Moves the icon to the end
            padding: '10px 15px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            cursor: 'pointer',
            width: '125px',
          }}
        >
          {sortOption} <FaAngleDown style={{ color: '#A1A1A1' }} />
        </button>
        {sortOpen && (
          <div
            style={{
              position: 'absolute',
              top: '40px',
              right: '0',
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              borderRadius: '4px',
              boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
              zIndex: 100,
              textTransform: 'capitalize',
              width: '125px',
            }}
          >
            {statusOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => handleSortChange(option.value)}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkflowSortToolbar;
